import { Product } from "../interfaces";

/* eslint-disable @typescript-eslint/no-explicit-any */
export type AgreementKey = 'Super App' | 'AudioBook' | 'Revista' | 'E-Book' | 'Literários' | 'Profissional' | 'Educa' | 'Infantil' | 'Revista Nacionais' | 'Revista Digital de Descontos' | 'Ecommerce' | 'Cinemas' | 'Lojas';

export const deriveAgreementKey = (name: any): AgreementKey | null => {
  if (!name) return null;
  if (name === 'Super App') return 'Super App';
  if (name === 'AudioBook') return 'AudioBook';
  if (name === 'Revista') return 'Revista';
  if (name === 'E-Book') return 'E-Book';
  if (name === 'Literários') return 'Literários';
  if (name === 'Profissional') return 'Profissional';
  if (name === 'Educa') return 'Educa';
  if (name === 'Infantil') return 'Infantil';
  if (name === 'Revista Nacionais') return 'Revista Nacionais';
  if (name === 'Revista Digital de Descontos') return 'Revista Digital de Descontos';
  if (name === 'Ecommerce') return 'Ecommerce';
  if (name === 'Cinemas') return 'Cinemas';
  if (name === 'Lojas') return 'Lojas';
  return null;
};

export const default_products: Product[] = [
  {
    id: 2,
    name: 'Literários',
    plans: [],
    default_product: {
      id: 1,
      name: 'Literários',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    sector: '1',
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
  {
    id: 6,
    name: 'Profissional',
    plans: [],
    default_product: {
      id: 2,
      name: 'Profissional',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    sector: '2',
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
  {
    id: 7,
    name: 'Educa',
    plans: [],
    default_product: {
      id: 3,
      name: 'Educa',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    sector: '4',
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
  {
    id: 8,
    name: 'Infantil',
    plans: [],
    default_product: {
      id: 4,
      name: 'Infantil',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    sector: '5',
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
  {
    id: 5,
    name: 'Audio Book',
    plans: [],
    default_product: {
      id: 5,
      name: 'Audio Book',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    sector: '1',
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
  {
    id: 4,
    name: 'Super App',
    plans: [],
    default_product: {
      id: 6,
      name: 'Super App',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
  {
    id: 3,
    name: 'Revista',
    plans: [],
    default_product: {
      id: 7,
      name: 'Revista',
      default_plans: [],
      active: false,
      created_at: '',
      updated_at: '',
      is_bookstore: false,
      is_superapp: true,
      create_landing: false,
      metadata: {},
    },
    active: false,
    created_at: '',
    updated_at: '',
    metadata: {},
    agreement: 1,
  },
];

export const images = {
  'Super App': '/assets/benefits/superapp.gif',
  'Audio Book': '/assets/benefits/audiobooks.gif',
  'E-Book': '/assets/benefits/livros.gif',
  Revista: '/assets/benefits/revista.gif',
  'Literários': '/assets/benefits/literarios.gif',
  'Profissional': '/assets/benefits/profissional.gif',
  'Educa': '/assets/benefits/educa.gif',
  'Infantil': '/assets/benefits/infantil.gif',
  'Revista Nacionais': '/assets/benefits/revista.gif',
  'Revista Digital de Descontos': '/assets/benefits/magazine-clube.gif',
  'Ecommerce': '/assets/benefits/ecommerce.gif',
  'Cinemas': '/assets/benefits/cinema.gif',
  'Lojas': '/assets/benefits/lojas.gif',
};

/** Determina o tipo de produto pelos metadados (Super App, Literários, Revista, etc.). */
export function getProductTypeFromMetadata(product: any): string {
  if (product?.default_product?.is_superapp) return 'Super App';
  const sectors = product?.metadata?.sectors?.value;
  if (sectors) {
    if (sectors.includes('1')) return 'Literários';
    if (sectors.includes('2')) return 'Profissional';
    if (sectors.includes('4')) return 'Educa';
    if (sectors.includes('5')) return 'Infantil';
  }
  if (product?.metadata?.hasAudioBook?.value === 'true') return 'AudioBook';
  if (product?.metadata?.hasMagazine?.value === 'true') return 'Revista';
  return product?.metadata?.type?.value || '';
}

/** Retorna a URL da imagem do tipo de produto (fallback quando não há logo). */
export function getProductImageByType(product: any): string {
  const type = getProductTypeFromMetadata(product);
  const imageKey = type === 'AudioBook' ? 'Audio Book' : type;
  return (imageKey && (images as Record<string, string>)[imageKey]) || '';
}

export const planTypes = {
  'Super App': 'Super App',
  'Audio Book': 'AudioBook',
  Revista: 'Revista',
  'E-Book': 'E-Book',
  'Literários': 'Literários',
  'Profissional': 'Profissional',
  'Educa': 'Educa',
  'Infantil': 'Infantil',
  'Revista Nacionais': 'Revista Nacionais',
  'Revista Digital de Descontos': 'Revista Digital de Descontos',
  'Ecommerce': 'Ecommerce',
  'Cinemas': 'Cinemas',
  'Lojas': 'Lojas',
};
